import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.networthGrowth || initialState;

export const selectNetworthGrowth = createSelector(
  [selectSlice],
  state => state,
);
